import { useMemo } from 'react';
import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import { Declaration } from 'store/declarations/declaration';
import { CdsDeclaration } from 'store/declarations/uk/cds-declaration';
import { getDeclarationPayload, getExporter } from 'views/declarations/utils/declaration-utils';

type Props = {
    declaration?: Declaration;
    dataTestId?: string;
};

const Consignor = ({ declaration, dataTestId }: Props) => {
    let payload = useMemo(() => getDeclarationPayload(declaration), [declaration]);

    if (!payload || !declaration) return <EmptyCell dataTestId={dataTestId} />;

    payload = (payload as CdsDeclaration)?.cdsDeclarationPayload ?? payload;
    const exporter = getExporter(payload as any);

    if (!exporter?.name) {
        return <EmptyCell dataTestId={dataTestId} />;
    }

    return <span data-testid={dataTestId}>{exporter.name}</span>;
};

export default Consignor;
